module.exports = __webpack_public_path__ + "img/download_ios.f9c6ec56.png";